import { testConnectorConfigSftpDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const testConnectorConfigSftpCallable = getCallable(
  testConnectorConfigSftpDefinition,
);
